'use client';

import { useState } from 'react';
import { Menu } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { trackContactClick, trackSimulateClick } from '@/lib/analytics';

interface NavLink {
  href: string;
  label: string;
}

interface MobileNavProps {
  navLinks: NavLink[];
}

export default function MobileNav({ navLinks }: MobileNavProps) {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 rounded-full text-navy-900 hover:bg-navy-50 transition-colors"
        >
          <Menu className="h-6 w-6" />
          <span className="sr-only">Abrir menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="w-[300px] sm:w-[350px] bg-white text-navy-900 shadow-2xl border border-navy-200"
      >
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <div className="w-8 h-8 bg-navy-900 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">P</span>
            </div>
            <span className="font-semibold text-navy-900">Patriar</span>
          </SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col gap-4 mt-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => {
                if (link.href === '#calculadora') trackSimulateClick('header_nav');
                setOpen(false);
              }}
              className="text-lg font-semibold text-navy-900 hover:text-gold-500 transition-colors py-2"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contato"
            onClick={() => {
              trackContactClick('whatsapp', 'mobile_nav');
              setOpen(false);
            }}
            className="mt-4 inline-flex items-center justify-center rounded-lg bg-gold-500 px-5 py-3 text-base font-semibold text-white hover:bg-gold-600 transition-colors"
          >
            Fale Conosco
          </a>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
